import { useEffect } from 'react'

import { PatientList as PopulationPatientList } from '../../components/Widgets/Population'
import { usePatientStore } from '../../stores/patient'
import { GenericWrapper } from './styles'

export function PatientList(): React.ReactNode {
  const resetPatient = usePatientStore((state) => state.reset)

  useEffect(() => {
    resetPatient()
  }, [])

  return (
    <GenericWrapper>
      <PopulationPatientList />
    </GenericWrapper>
  )
}
